export default "__VITE_ASSET__zofgWkM6__"